<template>
    <div>
        <h2>Weekly Time Table</h2>
        <button @click="showForm = true" class="btn btn-primary">Add Time Table</button>

        <table class="table mt-3" style="border: 1px solid black; border-collapse: collapse;">
            <thead>
                <tr>
                    <th>Time Slots</th>
                    <th v-for="day in days" :key="day.id" style="border: 1px solid black;">{{ day.name }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="slot in timeSlots" :key="slot.id">
                    <td style="border: 1px solid black;">{{ formatTime(slot.start_time) }} - {{
                        formatTime(slot.end_time) }}</td>
                    <td v-for="day in days" :key="day.id" style="border: 1px solid black;">
                        <div v-for="entry in getEntries(day.id, slot.id)" :key="entry.id" class="entry-box"
                            @click="selectEntry(entry)">
                            <i>{{ entry.counselor.user.name }}</i>
                            <hr>
                            <strong>{{ entry.group?.name }}</strong>
                            <div v-if="entry.timetable_agendas.length">
                                <div v-for="agenda in entry.timetable_agendas" :key="agenda.id">{{ agenda.agenda.title
                                }}</div>
                            </div>
                            <div v-else>None</div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Chatbox-style form -->
        <div v-if="showForm" class="chatbox">
            <div class="chatbox-header">
                <h3>{{ isEditing ? 'Edit Time Table' : 'Add Time Table' }}</h3>
                <button @click="resetForm" class="close-btn">×</button>
            </div>
            <div class="chatbox-body">
                <form @submit.prevent="saveItem">
                    <label>Day:</label>
                    <select v-model="form.day_id" class="form-control" required>
                        <option value="" disabled>Select Day</option>
                        <option v-for="day in days" :key="day.id" :value="day.id">{{ day.name }}</option>
                    </select>

                    <label>Group:</label>
                    <select v-model="form.group_id" class="form-control" required>
                        <option value="" disabled>Select Group</option>
                        <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
                    </select>

                    <label>Time Slot:</label>
                    <select v-model="form.time_slot_id" class="form-control" required>
                        <option value="" disabled>Select Time Slot</option>
                        <option v-for="slot in timeSlots" :key="slot.id" :value="slot.id">{{ formatTime(slot.start_time)
                            }} - {{ formatTime(slot.end_time) }}</option>
                    </select>

                    <label>Counselor:</label>
                    <select v-model="form.counselor_id" class="form-control" required>
                        <option value="" disabled>Select Counselor</option>
                        <option v-for="counselor in counselors" :key="counselor.id" :value="counselor.id">{{
                            counselor.user.name }}</option>
                    </select>

                    <label>Agendas:</label>
                    <Multiselect v-model="form.agenda_ids" style="width:93%;" :options="agendas" :multiple="true"
                        label="title" track-by="id" class="form-control">
                    </Multiselect>
                    <div class="mt-3">


                        <button type="submit" class="btn btn-success">Save</button>
                        <button type="button" class="btn btn-danger ms-2 cancel-btn" @click="resetForm">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
export default {
    components: {
        Multiselect
    },
    data() {
        return {
            weeklyTimeTables: [],
            days: [],
            groups: [],
            timeSlots: [],
            counselors: [],
            agendas: [],
            showForm: false,
            isEditing: false,
            form: {
                id: null,
                day_id: '',
                group_id: '',
                time_slot_id: '',
                counselor_id: '',
                agenda_ids: []
            },
        };
    },
    methods: {
        resetForm() {
            this.form = {
                id: null,
                day_id: '',
                group_id: '',
                time_slot_id: '',
                counselor_id: '',
                agenda_ids: []
            };
            this.showForm = false;
            this.isEditing = false;
        },
        selectEntry(entry) {
            this.form = { ...entry, agenda_ids: entry.timetable_agendas.map(a => a.agenda) };
            this.showForm = true;
            this.isEditing = true;
        },
        saveItem() {
            const url = this.isEditing ? `/weekly-timetables/${this.form.id}` : '/weekly-timetables';
            const method = this.isEditing ? 'put' : 'post';

            this.$api[method](url, this.form).then(() => {
                this.fetchData();
                this.resetForm();
            }).catch(error => {
                console.error('Error saving data:', error);
            });
        },
        formatTime(time) {
            const [hours, minutes] = time.split(":");
            const period = hours >= 12 ? "PM" : "AM";
            const formattedHours = hours % 12 || 12;
            return `${formattedHours}:${minutes} ${period}`;
        },
        getEntries(dayId, slotId) {
            return this.weeklyTimeTables.filter(item => item.day_id === dayId && item.time_slot_id === slotId);
        },
        fetchData() {
            this.$api.get('/weekly-timetables').then(res => this.weeklyTimeTables = res.data);
            this.$api.get('/days').then(res => this.days = res.data);
            this.$api.get('/groups').then(res => this.groups = res.data);
            this.$api.get('/time-slots').then(res => this.timeSlots = res.data);
            this.$api.get('/counselors').then(res => this.counselors = res.data);
            this.$api.get('/agendas').then(res => this.agendas = res.data);
        },
    },
    mounted() {
        this.fetchData();
    },
};
</script>

<style scoped>
@import "vue-multiselect/dist/vue-multiselect.min.css";

.chatbox {
    position: fixed;
    bottom: 0;
    right: 20px;
    width: 450px;
    background: white;
    border: 1px solid #222250;
    border-radius: 10px 10px 0 0;
    box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease-in-out;
    transform: translateY(0);
    min-height: 500px;
    height: auto !important;

}

.chatbox-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #222250;
    color: white;
    padding: 10px;
    border-radius: 10px 10px 0 0;
}

.chatbox-body {
    padding: 15px;
    /* max-height: 500px; */
    /* overflow-y: auto; */
    margin-bottom: 50px;

}

.close-btn {
    background: none;
    border: none;
    color: white;
    font-size: 20px;
    cursor: pointer;
}

.form-control {
    width: 100%;
    padding: 8px;
    margin: 5px 0;
    border-radius: 5px;
    border: 1px solid #ccc;
}

.entry-box {
    border: 1px solid #e3e3e3;
    border-radius: 16px;
    padding: 5px;
    margin-bottom: 5px;
    text-align: left;
}
</style>
